import * as types from "./mutation-types"
import "./state-types"
export default {
  [types.SAVE_FIELDS](state: StateProcessFields, obj: any) {
    localStorage.setItem("fields", JSON.stringify(obj))
    state.fields = obj
  },
}
